export default theme => ({
  cursorPointer: { cursor: 'pointer' },
  mainChart: {
    ...theme.apexchartsOverrides,
    '& .apexcharts-legend': {
      minWidth: 199
    }
  }
});
